import React from 'react';

import { translations } from 'i18n';
import { REMEMBER_ME_LOCAL_STORAGE_KEY } from 'utils/utils';

import styles from './style.module.scss';

const COGNITO_KEY_PREFIX = 'CognitoIdentityServiceProvider.';

// Remove the persisted Cognito session without relying on Amplify/React state,
// which may be what is broken
const clearCognitoSession = () => {
  [localStorage, sessionStorage].forEach((storage) => {
    try {
      Object.keys(storage)
        .filter((key) => key.startsWith(COGNITO_KEY_PREFIX))
        .forEach((key) => storage.removeItem(key));
    } catch (error) {
      console.error('Failed to clear session storage', error);
    }
  });
  try {
    localStorage.removeItem(REMEMBER_ME_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear remember me flag', error);
  }
  (window as any).ReactNativeWebView?.postMessage(JSON.stringify({ what: 'logout_from_portal' }));
};

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// Without this, any render error unmounts the whole app and leaves an empty page
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Uncaught render error', error, errorInfo);
  }

  reload = () => {
    window.location.reload();
  };

  signOutAndReload = () => {
    clearCognitoSession();
    window.location.assign('/login');
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className={styles.container}>
        <h1 className={styles.title}>{translations('ErrorBoundary.SomethingWentWrong')}</h1>
        <p className={styles.text}>{translations('ErrorBoundary.PleaseReloadThePage')}</p>
        <button className={styles.button} onClick={this.reload}>
          {translations('ErrorBoundary.Reload')}
        </button>
        <button className={styles.linkButton} onClick={this.signOutAndReload}>
          {translations('ErrorBoundary.SignOutAndReload')}
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
